import Button from 'devextreme-react/button';
import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useTitle } from '../../../../contexts/title';
import '../../../../css/dashboard.scss';
import { useGetStatistics } from '../../../../api/statistics';
import { useAuth } from '../../../../contexts/auth';
import { LoadPagePanel } from '../../../../components';
import { ActionRequiredCard } from '../../../common';
import CFINotesCard from './CFINotesCard';
import { BusinessFlow, ProductLine } from '../../../../types/enums';
import { useGetCompany } from '../../../../api/company';

export default function DealerDashboard() {
	const navigate = useNavigate();
	const pageTitle = useTitle();

	useEffect(() => {
		pageTitle.setTitle('Action Required Items');
	}, [pageTitle])

	const { user } = useAuth();
	const statistics = useGetStatistics(user?.companyId!, user?.userName!, user?.companyTypeId!);
	const dealer = useGetCompany(user?.companyId);

	const isLaminate = !!dealer.data?.productLines.find(x =>
		x.productLineID === ProductLine.LaminateInstall ||
		x.productLineID === ProductLine.LaminateDelivered);

	const isSmallProjects = !!dealer.data?.productLines.find(x => x.productLineCode === 'Small Projects');

	const isCabinets = !!dealer.data?.productLines.find(x => x.productLineID === ProductLine.Cabinets);

	return (
		<>
			<div className='content-block dashboard'>
				<LoadPagePanel visible={statistics.isLoading || statistics.isFetching} />

				{!statistics.isLoading &&
					<div>
						<div className='dx-clearfix'>
							<Button
								type='default'
								text="View in Table"
								icon="Inscyth-Action-Required"
								className='view-in-table-button' onClick={() => navigate('/dealer/action-required')}>
							</Button>
						</div>
						<div className='dashboard-section no-header'>
							<div className='ar-buttons-container'>
								{
									isCabinets &&
									<ActionRequiredCard
										text='Submit Cabinet Design'
										statData={statistics.data}
										statID={134}
										url='/dealer/action-required-orders/134'
										showPending={false}
										description={
											<div className='ar-description'>
												<div className='ar-description-active'>
													Active Orders: Orders received in the past two business days.
												</div>
												<div className='ar-description-pastdue'>
													Past Due Orders: Orders received more than two business days ago.
												</div>
											</div>
										}
									/>
								}
								<ActionRequiredCard
									text='Confirm Change Order'
									statData={statistics.data}
									statID={122}
									url='/dealer/action-required-orders/122'
									showPending={false}
									description={
										<div className='ar-description'>
											<div className='ar-description-active'>
												Active Orders: Orders received in the past two business days.
											</div>
											<div className='ar-description-pastdue'>
												Past Due Orders: Orders received more than two business days ago.
											</div>
										</div>
									}
								/>
								{
									isLaminate &&
									<ActionRequiredCard
										text='Upload Laminate Order Form'
										statData={statistics.data}
										statID={124}
										url='/dealer/action-required-orders/124'
										showPending={false}
										description={
											<div className='ar-description'>
												<div className='ar-description-active'>
													Active Orders: Orders received in the past one business day.
												</div>
												<div className='ar-description-pastdue'>
													Past Due Orders: Orders received more than one business day ago.
												</div>
											</div>
										}
									/>
								}
								{
									isSmallProjects &&
									<ActionRequiredCard
										text='Upload Vanity Order Form'
										statData={statistics.data}
										statID={123}
										url='/dealer/action-required-orders/123'
										showPending={false}
										description={
											<div className='ar-description'>
												<div className='ar-description-active'>
													Active Orders: Orders received in the past one business day.
												</div>
												<div className='ar-description-pastdue'>
													Past Due Orders: Orders received more than one business day ago.
												</div>
											</div>
										}
									/>
								}
								{
									(dealer.data?.businessFlowID === BusinessFlow.CTG ||
										dealer.data?.businessFlowID === BusinessFlow.Online) && dealer.data?.isParent &&
									<ActionRequiredCard
										text='Corporate to Accept Change Order'
										statData={statistics.data}
										statID={125}
										url='/dealer/action-required-orders/125'
										showPending={false}
										description={
											<div className='ar-description'>
												<div className='ar-description-active'>
													Active Orders: Orders received in the past two business days.
												</div>
												<div className='ar-description-pastdue'>
													Past Due Orders: Orders received more than two business days ago.
												</div>
											</div>
										}
									/>
								}
								{
									isCabinets &&
									<ActionRequiredCard
										text='Enter Estimated Cabinet Delivery Date'
										statData={statistics.data}
										statID={135}
										url='/dealer/action-required-orders/135'
										showPending={false}
										description={
											<div className='ar-description'>
												<div className='ar-description-active'>
													Active Orders: Orders received in the past two business days.
												</div>
												<div className='ar-description-pastdue'>
													Past Due Orders: Orders received more than two business days ago.
												</div>
											</div>
										}
									/>
								}
								{
									isCabinets &&
									<ActionRequiredCard
										text='Enter Cabinet PO Received Date'
										statData={statistics.data}
										statID={137}
										url='/dealer/action-required-orders/137'
										showPending={false}
										description={
											<div className='ar-description'>
												<div className='ar-description-active'>
													Active Orders: Orders received in the past two business days.
												</div>
												<div className='ar-description-pastdue'>
													Past Due Orders: Orders received more than two business days ago.
												</div>
											</div>
										}
									/>
								}
								<CFINotesCard
									statData={statistics.data}
									statID={20000}
									url='/dealer/cfi-notes' />
							</div>
						</div>
					</div>
				}
			</div>
		</>)
}
